export default function () {
  return [
    {
      type: 'Input',
      title: '申请名称',
      [$field]: 'applyName',
      colSpan: 16,
      rules: ['required']
    },
    {
      type: 'DatePicker',
      title: '申请日期',
      [$field]: 'applyDate',
      colSpan: 8,
      readOnly: true,
      rules: []
    },
    {
      type: 'Input',
      title: '申请人',
      [$field]: 'createUserName',
      readOnly: true,
      colSpan: 8,
      rules: []
    },
    {
      type: 'Input',
      title: '申请人邮箱',
      [$field]: 'createUserEmail',
      readOnly: true,
      colSpan: 8,
      rules: []
    },
    {
      type: 'Input',
      title: '申请人手机',
      [$field]: 'createUserPhone',
      readOnly: true,
      colSpan: 8,
      rules: []
    },
    {
      type: 'universalTree',
      title: '申请组织',
      [$field]: 'createOrgName',
      props: {
        title: '选择党组织',
        tipsTitle: '责任党组织名称：',
        isRootOrgConfig: true,
        selected: false,
        showLazyTree: true,
        treeParams: {
          scope: 2,
          selectId: '',
          orgId: sessionStorage.getItem('listOrgId')
        },
        treeType: {
          type: 'single-all'
        },
        treeMap: {
          key: 'orgId'
        }
      },
      readOnly: true,
      colSpan: 8,
      rules: []
    },
    {
      type: 'textarea',
      title: '申请原因',
      [$field]: 'applyReason',
      colSpan: 24,
      rules: ['required']
    },
    {
      type: 'Select',
      title: '提交给',
      [$field]: 'submitToOrgName',
      optionList: [
        {
          label: '向集团纪检组织申请',
          value: '1'
        },
        {
          label: '向现地党组织纪检组织申请',
          value: '2'
        }
      ],
      colSpan: 8,
      rules: ['required']
    },
    {
      type: 'Radio',
      title: '是否需盖纪委章',
      [$field]: 'isSeal',
      optionList: this.dictMap['KZ41'],
      colSpan: 8,
      rules: ['required']
    },
    {
      type: 'RemoteSelect',
      title: '申请类型',
      [$field]: 'applyType',
      props: {
        url: 'module/dict/outGetList',
        map: {
          title: 'title',
          value: 'value'
        },
        params: {
          dictCode: 'BOE85',
          merge: false
        }
      },
      rules: ['required']
    },
    {
      type: 'FileUpload',
      title: '廉洁无问题证明文件模板',
      [$field]: 'certificateFile',
      props: {
        data: {
          groupId: this.groupId
        },
        multiple: false,
        isShowFileList: true
      },
      colSpan: 24,
      rules: []
    }
  ]
}
